module.exports = __webpack_public_path__ + "img/profile_box_gray_place_name.49d4fc7f.svg";